module.exports = {
  tmpdir: function () { return '/tmp'; },
  homedir: function () { return '/'; },
  platform: function () { return 'browser'; },
  arch: function () { return 'x64'; },
  EOL: '\n'
};
